import { Liquid } from 'liquidjs';

const ccmCustomFileSystem = {
    resolve: (root, file) => {
        if (!file.endsWith('.html')) {
            file += '.html';
        }
        return `${root}/${file}?v=${build}`;
    },
    exists: (file) => {
        // Check existence by doing a HEAD request
        return fetch(file, { method: 'HEAD' })
            .then(response => response.ok)
            .catch(() => false);
    },
    existsSync: (file) => {
        // Synchronous implementation using XMLHttpRequest
        const xhr = new XMLHttpRequest();
        try {
            xhr.open('HEAD', file, false); // false makes it synchronous
            xhr.send(null);
            return xhr.status >= 200 && xhr.status < 300;
        } catch (e) {
            return false;
        }
    },
    readFile: (file, encoding) => {
        return fetch(file)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load file: ${file}`);
                }
                return response.text();
            });
    },
    readFileSync: (file, encoding) => {
        // Synchronous implementation using XMLHttpRequest
        const xhr = new XMLHttpRequest();
        try {
            xhr.open('GET', file, false); // false makes it synchronous
            xhr.send(null);
            if (xhr.status >= 200 && xhr.status < 300) {
                return xhr.responseText;
            } else {
                throw new Error(`Failed to load file: ${file}`);
            }
        } catch (e) {
            throw new Error(`Failed to load file: ${file}`);
        }
    }
}

export class TemplateService {
    static Init() {
        this.engine = this.GetEngine();
    }

    static GetEngine() {
        this.engine = new Liquid({
            root: '/assets/js/dist/templates',
            extname: '.html', // extension used for layouts/includes (.html) templates
            fs: ccmCustomFileSystem
        });

        return this.engine;
    }

    static async GetRenderedTemplate(templateName, data) {

        if (!this.engine) {
            this.Init();
        }

        return await this.engine.renderFile(`${templateName}`, data);
    }

    static GetRenderedTemplateAsync(templateName, data) {

        if (!this.engine) {
            this.Init();
        }

        return this.engine.renderFile(`${templateName}`, data);
    }

    static GetRenderedTemplateSync(templateName, data) {
        if (!this.engine) {
            this.Init();
        }

        DEBUG && console.info("====> Rendering Template - " + templateName);

        return this.engine.renderFileSync(`${templateName}`, data);
    }

    static RenderTemplateElement(templateName, data, element) {
        if (!this.engine) {
            this.Init();
        }

        return this.engine.renderFile(`${templateName}`, data)
            .then(content => {
                element.innerHTML = content;
            });
    }
}